import { useAtomCallback } from 'jotai/utils';

import { useTranslate } from '@growtherapy/i18n';

import { logger } from '../../datadog/logger';
import { toast } from '../../toasts';
import { isScreenShareModeAtom } from '../../video-sdk';
import { isWhiteboardModeAtom } from '../messages/state';
import useScreenShareCallbacks, { ShareScreenOptions } from './useScreenShareCallbacks';
import { useWhiteboardCallbacks } from './useWhiteboardCallbacks';

type SwitchToMode = (...args: ['screenshare', ShareScreenOptions] | ['screenshare'] | ['whiteboard']) => void;

export function useSessionModeCallbacks() {
  const t = useTranslate();
  const getIsScreenshareMode = useAtomCallback((get) => get(isScreenShareModeAtom));
  const getIsWhiteboardMode = useAtomCallback((get) => get(isWhiteboardModeAtom));

  const { startWhiteboard, stopWhiteboard } = useWhiteboardCallbacks();
  const { triggerBrowserScreenShare, stopScreenShare } = useScreenShareCallbacks((error: Error) => {
    toast.error(t('telehealth-core:screenShare.thereWasAnErrorSharingYourScreen'));
    logger.error('Error starting screen share', {}, error);
  });

  function stopCurrentMode() {
    if (getIsScreenshareMode()) {
      stopScreenShare();
    } else if (getIsWhiteboardMode().value) {
      stopWhiteboard();
    }
  }

  const switchToMode: SwitchToMode = (mode, options?) => {
    stopCurrentMode();
    switch (mode) {
      case 'screenshare': {
        triggerBrowserScreenShare(options);
        break;
      }
      case 'whiteboard': {
        startWhiteboard();
        break;
      }
    }
  };

  return {
    switchToMode,
    stopCurrentMode,
  };
}
